import React from "react";
import { Button, Modal, ModalBody, ModalHeader } from "reactstrap";
import { FiLink } from "react-icons/fi";
import { LuShieldCheck } from "react-icons/lu";
import ShareableLinkField from "./ShareTrivia/ShareableLinkField";
import {
  SHARE_LINK_DIALOG_TITLE,
  SHARE_NOTE_LABEL,
  SHARE_LINK_PRIVACY_REMINDER,
} from "./ShareTrivia/shareCopy";
import { SHORT_LINK_ITEM_TYPES, SHORT_LINK_SOURCES } from "../../../utils/trivvyShortLink";
import "./ShareTrivia/sharepage.css";

// TBV-938 / TBV-951: the list Copy Link modal for Trivvys and Library items,
// laid out like the Share page's Copy Link modal: the item's sharing options
// (`children`) above its permanent short link. The link is resolved here (or
// taken from the row's server-built shortUrl) and copied by a separate, fresh
// user click on Copy — Safari / mobile drop clipboard writes chained after a
// network request.
const ShortLinkCopyDialog = ({
  item,
  itemType = SHORT_LINK_ITEM_TYPES.TRIVVY,
  fallbackUrl,
  onClose,
  onResolved,
  children,
}) => {
  const isOpen = Boolean(item);
  return (
    <Modal isOpen={isOpen} toggle={onClose} className="shareModal" centered>
      <ModalHeader toggle={onClose}>
        <div className="share_title_chip">
          <FiLink />
        </div>
        <div className="share_title_text">
          <span>{SHARE_LINK_DIALOG_TITLE}</span>
        </div>
      </ModalHeader>
      <ModalBody className="pb-4">
        {isOpen && (
          <>
            {children}
            <div className="share_privacy_reminder" role="note">
              <LuShieldCheck size={16} />
              <span>
                <b>{SHARE_NOTE_LABEL}</b> {SHARE_LINK_PRIVACY_REMINDER}
              </span>
            </div>
            <div className="mt-2">
              <ShareableLinkField
                itemType={itemType}
                itemId={item._id}
                source={SHORT_LINK_SOURCES.LIST_MENU}
                knownShortUrl={item.shortUrl}
                fallbackUrl={fallbackUrl}
                onResolved={(shortUrl) => {
                  if (onResolved) {
                    onResolved(item._id, shortUrl);
                  }
                }}
              />
            </div>
          </>
        )}
        <div className="share_footer">
          <Button className="share_btn_text" onClick={onClose}>
            Close
          </Button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default ShortLinkCopyDialog;
